import { BASE_URI } from '@/shared/config';

export const getRawMeshViewerLink = (studyID: string) =>
  `${BASE_URI}/studio/viewer/?study_uid=${studyID}&raw_mesh_viewer`;
